import isObject from 'lodash-es/isObject';

import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TableAttrs } from 'book-widgets/interfaces';

import { ColSpecMap } from './table';
import { TableHeadRow } from './table-head-row';

export interface TableHeadProperties {
	thead: TopicDetails;
	widths: ColSpecMap;
}

const factory = create({ theme }).properties<TableHeadProperties>();

export const TableHead = factory(({ properties }) => {
	const { thead, widths } = properties();
	const { children } = thead;
	const rows: TopicDetails[] = children!.filter((kid) => {
		return isObject(kid) && 'row' in kid;
	});

	return v(
		'thead',
		{},
		rows.map((row) => {
			const entries: TopicDetails[] = row.children || (row as any).row.children;
			const rowattrs: TableAttrs = row.attributes as TableAttrs;
			return w(TableHeadRow, { entries, rowattrs, widths });
		})
	);
});
